module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_26.7e545b45.png";